// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".application-selectable{display:grid;grid-template-columns:1fr}.application-card{border-width:1px;border-color:#d8d8d8;border-radius:4px;padding:10px}.application-set{background-color:#f4f6f8;border-style:solid}.application-unset{height:100%;background-color:#fff;border-style:dashed;align-self:center;justify-self:center}.application-name{font-size:18px;line-height:16px}.application-email{font-size:13px}.application-type{text-transform:uppercase;font-size:12px}", ""]);
// Exports
module.exports = exports;
